import script from "./MessagesModule.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesModule.vue?vue&type=script&setup=true&lang=js"

import "./MessagesModule.vue?vue&type=style&index=0&id=99285916&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99285916"]])

export default __exports__